<template>
  <div>
    <h1 class="my-5 text-4xl font-extrabold tracking-tight text-gray-900">Numéro de marquage</h1>

    <div class="mt-5">
      <label for="markingNumber" class="block text-sm font-medium text-gray-700">
        Renseignez le numéro de marquage du produit
      </label>
      <input
        type="text"
        id="markingNumber"
        v-model="markingNumber"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
        required
      />
    </div>

    <div class="mt-5 flex justify-between gap-5">
      <GenericButton @click="$emit('previous')" secondary no-scaling class="mr-2">Précédent</GenericButton>
      <div class="flex-1 pl-2">
        <GenericButton @click="$emit('submit')" no-scaling class="w-full" :disabled="!requiredFieldsFilled">
          Suivant
        </GenericButton>
      </div>
    </div>
  </div>
</template>

<script>
import { GenericButton } from "@estaly/ui";

export default {
  components: {
    GenericButton,
  },
  props: {
    formData: {
      type: Object,
      required: true,
    },
    componentStep: {
      type: Number,
      required: true,
    },
    currentStep: {
      type: Number,
      required: true,
    },
    contractCategory: {
      required: true,
    },
  },
  emits: ["submit", "previous"],
  data() {
    return {
      requiredFieldsFilled: false,
      markingNumber: "",
    };
  },
  watch: {
    markingNumber(value) {
      this.formData.set("bike_marking_number", value);
      this.updateRequiredFieldsFilled();
    },
    currentStep(step, previous) {
      if (step !== this.componentStep) return;
      if (["bikes", "edpm", "bikes_simple", "bikes_premium"].includes(this.contractCategory)) {
        return;
      }
      // Clean & skip
      this.formData.delete("bike_marking_number");
      previous < step ? this.$emit("submit") : this.$emit("previous");
    },
  },
  methods: {
    updateRequiredFieldsFilled() {
      this.requiredFieldsFilled = this.markingNumber.trim() !== "";
    },
  },
};
</script>
